var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-card",
    { staticStyle: { height: "100%" }, attrs: { bordered: false } },
    [
      _c(
        "div",
        { staticStyle: { "padding-bottom": "2px" } },
        [
          _c("a-alert", { attrs: { type: "warning", "show-icon": "" } }, [
            _c(
              "div",
              {
                staticStyle: { width: "100%" },
                attrs: { slot: "message" },
                slot: "message",
              },
              [
                _c("span", [_vm._v("路由配置请慎重")]),
                _c(
                  "span",
                  {
                    staticStyle: {
                      display: "inline-block",
                      float: "right",
                      "padding-right": "5px",
                    },
                  },
                  [
                    _c(
                      "a",
                      { on: { click: _vm.clearRedis } },
                      [
                        _c("a-icon", { attrs: { type: "reload" } }),
                        _vm._v("清除缓存"),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ],
        1
      ),
      _c("div", {
        style: { height: _vm.editorHeight + "px", width: "100%" },
        attrs: { id: _vm.eleId },
      }),
      _c(
        "div",
        { staticStyle: { "text-align": "center", "padding-top": "10px" } },
        [
          _c(
            "a-button",
            {
              staticStyle: { width: "160px" },
              attrs: { type: "primary" },
              on: { click: _vm.submitForm },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }